module.exports = __webpack_public_path__ + "static/settings-icon-56d72ea8c895e4b2dcdffc0b6f492088.png";